// extracted by mini-css-extract-plugin
export default {"list-item":"Snackbar-3FWyH__list-item","base-snackbar":"Snackbar--NaHu__base-snackbar"};